const EMAILJS_API_URL = "https://api.emailjs.com/api/v1.0/email/send";

const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || "";
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || "";
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "";

export function isEmailJsConfigured() {
  return Boolean(
    EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID && EMAILJS_PUBLIC_KEY,
  );
}

export async function submitContactMessage(payload) {
  if (!isEmailJsConfigured()) {
    throw new Error("EmailJS is not configured.");
  }

  const templateParams = {
    from_name: payload.name.trim(),
    from_email: payload.email.trim().toLowerCase(),
    reply_to: payload.email.trim().toLowerCase(),
    subject: payload.subject.trim(),
    message: payload.message.trim(),
    submitted_at: new Date().toLocaleString(),
    page_url: typeof window !== "undefined" ? window.location.href : "",
  };

  const response = await fetch(EMAILJS_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      service_id: EMAILJS_SERVICE_ID,
      template_id: EMAILJS_TEMPLATE_ID,
      user_id: EMAILJS_PUBLIC_KEY,
      template_params: templateParams,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();

    throw new Error(errorText || "EmailJS request failed.");
  }

  return {
    success: true,
  };
}
